const VendorType = {
  SET_ADD_VENDOR: "SET_ADD_VENDOR",
  SET_VENDOR_LIST: "SET_VENDOR_LIST",
  SET_UPDATE_VENDOR: "SET_UPDATE_VENDOR",
};

export interface AddVendor {
  company_name: string;
  name: string;
  mobile: number;
  email: string;
  country: string;
  state: string;
  district: string;
  pincode: number;
  address: string;
  gst_no: string;
}

export interface GetVendor {
  limit: number;
  search: any;
  page: number;
}

export interface UpdateVendor {
  id: number;
  company_name: string;
  name: string;
  mobile: number;
  email: string;
  country: string;
  state: string;
  district: string;
  pincode: number;
  address: string;
  gst_no: string;
}

export interface DeleteVendor {
  id: number;
}

export default VendorType;
